import {Component, forwardRef, Inject, OnInit} from '@angular/core';
import {NavigationService} from "../../shared/services/navigation.service";
import {
  getAuthorizeToken, getIdentityToken, IKnowAuthorization, IKnowIdentity, User,
  UserSession
} from "@westjetairlines/wjesd-oauth2-library";
import {Roles} from "../../shared/models/roles";
import {SpinnerComponent as Spinner} from "@westjetairlines/wjesd-component-library";

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.css']
})
export class NavigationComponent implements OnInit {
  private currentUser: User = User.empty();
  isFavourAdmin: boolean = false;
  isWaiverAdmin: boolean = false;
  isAuthenticated: boolean = false;
  isIataAdmin: boolean = false;
  constructor(private navigationService: NavigationService, @Inject(forwardRef(() => getIdentityToken)) private identityProvider: IKnowIdentity,
              @Inject(forwardRef(() => getAuthorizeToken)) private authService: IKnowAuthorization) { }

  ngOnInit() {
    Spinner.start();
    var self = this;
    this.authService.validateSession(null).subscribe((session: UserSession) => {
      self.isAuthenticated = session.isValid;
      if (self.isAuthenticated) {
        this.identityProvider.getCurrent().subscribe(data => {
          self.currentUser = data;
          self.isFavourAdmin = self.currentUser.isInRole(Roles.FavoursAdmin);
          self.isWaiverAdmin = self.currentUser.isInRole(Roles.WaiversAdmin);
          self.isIataAdmin = self.currentUser.isInRole(Roles.IataAdmin);
          Spinner.stop();
        },
        err => {
          console.log(err);
          Spinner.stop();
        },
        () => {
        });
      }
      else {
        console.log('session validation failed');
        Spinner.stop();
      }
    },
    err => {
      console.error(err);
      Spinner.stop();
    },
    () => {
      console.log('validation complete');
    });


  }

  onCreate() {
    this.navigationService.publishCreateStarted();
  }

}



// WEBPACK FOOTER //
// ./src/app/layout/navigation/navigation.component.ts